import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getAllParentIds } from './getAllParentIds';

/**
 * Given a flat list of nestable items and one of the items,
 * this function returns all children of that item.
 */

export function getAllChildren(items, parentId) {
  var children = items.filter(function (item) {
    return getAllParentIds(items, item).includes(parentId);
  });
  return children;
}